import checkout from '../modules/checkoutModule';
import initBrandsFilter from "../modules/initBrandsFilter";
import header from '../modules/header/index';

jQuery(function() {
    header();
    checkout();
    initBrandsFilter();
})